// extracted by mini-css-extract-plugin
module.exports = {"menu-primitive":"styles_menu-primitive__ckwoH","width-full":"styles_width-full__3quax"};